import { AgentComponentType, componentTypeUsesTools } from '@reach/shared-types/agent-components';
import { COMPONENT_PLACEHOLDERS, COMPONENT_TYPE_COPY } from '../agents-copy';
import type { ComponentDraft, ComponentDraftChange } from './component-draft';
import { COMPONENT_PAGE_COPY } from './component-page-copy';
import { FormCard } from './FormCard';
import { TextField } from './TextField';
import { ToolsField } from './ToolsField';

interface AgentInstructionsCardProps {
  type: AgentComponentType;
  draft: ComponentDraft;
  onDraftChange: (change: ComponentDraftChange) => void;
}

export const AgentInstructionsCard = ({ type, draft, onDraftChange }: AgentInstructionsCardProps) => {
  const componentIsSkill = type === AgentComponentType.SKILL;
  const componentUsesTools = componentTypeUsesTools(type);
  const { instructionsHelp } = COMPONENT_TYPE_COPY[type];
  const placeholders = COMPONENT_PLACEHOLDERS[type];

  return (
    <FormCard
      title={COMPONENT_PAGE_COPY.agentHeading}
      description={COMPONENT_PAGE_COPY.agentDescription}>
      {componentIsSkill && (
        <TextField
          label={COMPONENT_PAGE_COPY.triggerLabel}
          help={COMPONENT_PAGE_COPY.triggerHelp}
          placeholder={placeholders.trigger}
          value={draft.trigger}
          required
          onChange={trigger => onDraftChange({ trigger })}
        />
      )}
      <TextField
        label={COMPONENT_PAGE_COPY.instructionsLabel}
        help={instructionsHelp}
        placeholder={placeholders.instructions}
        value={draft.instructions}
        required
        multiline
        rows={10}
        onChange={instructions => onDraftChange({ instructions })}
      />
      {componentUsesTools && (
        <ToolsField
          toolDefinitionIds={draft.toolDefinitionIds}
          onChange={toolDefinitionIds => onDraftChange({ toolDefinitionIds })}
        />
      )}
    </FormCard>
  );
};
